import * as ApiNames from 'self-service-api/constants/ApiNames';
import { AUTOMATE_AND_PERSONALIZE_ENGAGEMENT, AUTOMATE_BUSINESS_PROCESSES, BUILD_CUSTOM_REPORTS, CONFIGURE_PRICE_QUOTE, CONNECT_SERVICE_TO_FRONT_OFFICE, EXPAND_CUSTOMER_RELATIONSHIPS, MANAGE_GROWING_TEAM, MANAGE_SCALING_BUSINESS, MONITOR_AND_CLEAN_DATA, OPTIMIZE_CAMPAIGN_CONVERSION, ORCHESTRATE_EFFICIENT_CAMPAIGNS, PERSONALIZE_OUTREACH, SCALE_SUPPORT } from 'self-service-api/constants/BizObjectives';
export const UpgradeTrialPageConfig = {
  [ApiNames.SALES_HUB_PROFESSIONAL]: {
    [PERSONALIZE_OUTREACH]: {
      title: 'interstitial.hc0119.businessObjectives.personalizeYourOutreach.header',
      subtitle: 'interstitial.hc0119.businessObjectives.personalizeYourOutreach.body',
      illustration: 'personalization-tokens'
    },
    [MANAGE_GROWING_TEAM]: {
      title: 'interstitial.hc0119.businessObjectives.manageYourGrowingTeam.header',
      subtitle: 'interstitial.hc0119.businessObjectives.manageYourGrowingTeam.body',
      illustration: 'deal-pipeline-rules'
    },
    [CONFIGURE_PRICE_QUOTE]: {
      title: 'interstitial.hc0119.businessObjectives.configurePriceQuote.header',
      subtitle: 'interstitial.hc0119.businessObjectives.configurePriceQuote.body',
      illustration: 'electronic-signature'
    }
  },
  [ApiNames.MARKETING_HUB_PROFESSIONAL]: {
    [AUTOMATE_AND_PERSONALIZE_ENGAGEMENT]: {
      title: 'interstitial.hc0119.businessObjectives.automateAndPersonalizeYourEngagement.header',
      subtitle: 'interstitial.hc0119.businessObjectives.automateAndPersonalizeYourEngagement.body',
      illustration: 'social'
    },
    [ORCHESTRATE_EFFICIENT_CAMPAIGNS]: {
      title: 'interstitial.hc0119.businessObjectives.orchestrateEfficientCampaigns.header',
      subtitle: 'interstitial.hc0119.businessObjectives.orchestrateEfficientCampaigns.body',
      illustration: 'content-strategy'
    },
    [OPTIMIZE_CAMPAIGN_CONVERSION]: {
      title: 'interstitial.hc0119.businessObjectives.optimizeCampaignConversion.header',
      subtitle: 'interstitial.hc0119.businessObjectives.optimizeCampaignConversion.body',
      illustration: 'leads'
    },
    [BUILD_CUSTOM_REPORTS]: {
      title: 'interstitial.hc0119.businessObjectives.buildCustomReports.header',
      subtitle: 'interstitial.hc0119.businessObjectives.buildCustomReports.marketing.body',
      illustration: 'add-on-reporting'
    }
  },
  [ApiNames.OPERATIONS_HUB_PROFESSIONAL]: {
    [AUTOMATE_BUSINESS_PROCESSES]: {
      title: 'interstitial.hc0119.businessObjectives.automateBusinessProcesses.header',
      subtitle: 'interstitial.hc0119.businessObjectives.automateBusinessProcesses.body',
      illustration: 'workflows'
    },
    [MONITOR_AND_CLEAN_DATA]: {
      title: 'interstitial.hc0119.businessObjectives.monitorAndCleanData.header',
      subtitle: 'interstitial.hc0119.businessObjectives.monitorAndCleanData.body',
      illustration: 'record-data-density-modal'
    },
    [MANAGE_SCALING_BUSINESS]: {
      title: 'interstitial.hc0119.businessObjectives.manageScalingBusiness.header',
      subtitle: 'interstitial.hc0119.businessObjectives.manageScalingBusiness.body',
      illustration: 'business-hours'
    },
    [BUILD_CUSTOM_REPORTS]: {
      title: 'interstitial.hc0119.businessObjectives.buildCustomReports.header',
      subtitle: 'interstitial.hc0119.businessObjectives.buildCustomReports.operations.body',
      illustration: 'add-on-reporting'
    }
  },
  [ApiNames.SERVICE_HUB_PROFESSIONAL]: {
    [SCALE_SUPPORT]: {
      title: 'interstitial.hc0119.businessObjectives.scaleSupport.header',
      subtitle: 'interstitial.hc0119.businessObjectives.scaleSupport.body',
      illustration: 'customer-support'
    },
    [CONNECT_SERVICE_TO_FRONT_OFFICE]: {
      title: 'interstitial.hc0119.businessObjectives.connectServiceToFrontOffice.header',
      subtitle: 'interstitial.hc0119.businessObjectives.connectServiceToFrontOffice.body',
      illustration: 'forecasting'
    },
    [EXPAND_CUSTOMER_RELATIONSHIPS]: {
      title: 'interstitial.hc0119.businessObjectives.expandCustomerRelationships.header',
      subtitle: 'interstitial.hc0119.businessObjectives.expandCustomerRelationships.body',
      illustration: 'service-hub-professional'
    }
  }
};